import { Api } from '@monorepo/shared/apiClient';
import React from 'react';

export const noLogEntriesGeneratedError = 'NO_LOG_ENTRIES_GENERATED';

export const getFooterErrorMessage = (): NonNullable<React.ReactNode> => (
  <>
    Please try again later. If the issue persists please reach out to{' '}
    <strong>help@mapistry.com</strong>
  </>
);

const errorMessageResponses = {
  defaultErrorMessage: 'Upload failure. Please try again.',
  noLogEntriesGeneratedMessage:
    'No Log entries were generated. Try uploading a different file or format or adjusting your AI model settings.',
};

export const getErrorMessage = (
  error?: Api.ErrorResponse,
): NonNullable<React.ReactNode> => {
  if (!error?.data) {
    return errorMessageResponses.defaultErrorMessage;
  }

  if (typeof error.data === 'object') {
    return error.data.message || errorMessageResponses.defaultErrorMessage;
  }

  if (error.data === noLogEntriesGeneratedError) {
    return errorMessageResponses.noLogEntriesGeneratedMessage;
  }

  return error.data;
};
